import React, { useState } from "react";
import {
  download,
  generateCsv,
  mkConfig,
} from "export-to-csv";
import {
  Checkbox,
  Button,
  FormControlLabel,
  Dialog,
  DialogContent,
  Stack,
} from "@mui/material";
import * as XLSX from "xlsx";
import type {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "material-react-table";
import { useGetAllReportClientiVersore } from "./Services";
import { ReportClientiVersore } from "./types";

interface ReportClientiVersoreExpProps {
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  globalFilter: string;
  sorting: MRT_SortingState;
  onClose: () => void;
}

const fieldDefinitions: {
  key: keyof ReportClientiVersore;
  label: string;
}[] = [
  { key: "datareg", label: "Data" },
  { key: "desprog", label: "Progetto" },
  { key: "ore", label: "Ore" },
  { key: "nomedip", label: "Operatore" },
  { key: "note", label: "Note" },

];

const ReportClientiVersoreExp: React.FC<ReportClientiVersoreExpProps> = ({
  pagination,
  columnFilters,
  globalFilter,
  sorting,
  onClose,
}) => {
  const { data: { results = [] } = {} } = useGetAllReportClientiVersore(
    { pageIndex: 0, pageSize: 100000 },
    columnFilters,
    globalFilter,
    sorting
  );

  const [selectedFields, setSelectedFields] = useState<
    (keyof ReportClientiVersore)[]
  >(fieldDefinitions.map((f) => f.key));

  const handleFieldToggle = (field: keyof ReportClientiVersore) => {
    setSelectedFields((prevFields) =>
      prevFields.includes(field)
        ? prevFields.filter((item) => item !== field)
        : [...prevFields, field]
    );
  };

  const generateExcelData = () => {
    return results.map((item) => {
      const rowData: any = {};
      fieldDefinitions.forEach(({ key, label }) => {
        if (selectedFields.includes(key)) {
          rowData[label] = item[key] || "";
        }
      });
      return rowData;
    });
  };

  const handleExportExcel = () => {
    const excelData = generateExcelData();
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReportClientiVersore");
    XLSX.writeFile(workbook, "reportclientiversore.xlsx");
  };

  const selectedHeaders = fieldDefinitions
    .filter(({ key }) => selectedFields.includes(key))
    .map(({ label }) => label);

  const selectedKeys = fieldDefinitions
    .filter(({ key }) => selectedFields.includes(key))
    .map(({ key }) => key);

const csvConfig = mkConfig({
  filename: "ReportClientiVersore",
  fieldSeparator: ";",
  decimalSeparator: ",",
  useKeysAsHeaders: true, // use transformed object keys as headers
  showColumnHeaders: true,
});

const handleExportCSV = () => {
  const selectedData = results.map((item) => {
    const rowData: any = {};
    fieldDefinitions.forEach(({ key, label }) => {
      if (selectedFields.includes(key)) {
        rowData[label] = item[key] || "";
      }
    });
    return rowData;
  });

  const csv = generateCsv(csvConfig)(selectedData);
  download(csvConfig)(csv);
};


  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="md">
      <DialogContent>
        <h4>Seleziona Campi da esportare:</h4>
        <form>
           <Stack direction="row" spacing={2} sx={{width: '100%'}}>
            {fieldDefinitions.map(({ key, label }) => (
              <FormControlLabel
                key={key}
                control={
                  <Checkbox
                    checked={selectedFields.includes(key)}
                    onChange={() => handleFieldToggle(key)}
                  />
                }
                label={label}
              />
            ))}
          </Stack>
        </form>
      </DialogContent>

      <DialogContent>
       <Stack direction="row" spacing={2} sx={{width: '100%'}}>
          <Button
            fullWidth
            color="primary"
            variant="outlined"
            onClick={() => setSelectedFields(fieldDefinitions.map((f) => f.key))}
          >
            SELEZIONA TUTTI
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="outlined"
            onClick={() => setSelectedFields([])}
          >
            DESELEZ. TUTTI
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleExportCSV}
          >
            EXPORT TO CSV
          </Button>
          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={handleExportExcel}
          >
            EXPORT TO EXCEL
          </Button>
          <Button
            fullWidth
            variant="contained"
            onClick={onClose}
            color="error"
          >
            CHIUDI
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ReportClientiVersoreExp;
